import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MessageSquare, Building2, Users, FileText, Globe } from 'lucide-react';
export function ContactPage() {
  const contactReasons = [{
    icon: <Building2 size={24} data-id="element-270" data-mp="2dwb0s2ivv1pv" />,
    title: 'Partnership Inquiries',
    description: 'Explore collaboration opportunities with educational institutions, employers, governments, or research organizations.'
  }, {
    icon: <Users size={24} data-id="element-271" data-mp="2469oe7zw77qs" />,
    title: 'Platform Demos',
    description: 'Request a demonstration of CJI, NCJI, or the broader SyNeural platform for your organization.'
  }, {
    icon: <FileText size={24} data-id="element-272" data-mp="1v8pi2kn6al9b" />,
    title: 'Research Collaboration',
    description: 'Discuss joint research initiatives, pilot programs, or academic partnerships.'
  }, {
    icon: <Globe size={24} data-id="element-273" data-mp="1l9gt6675zwtt" />,
    title: 'Government & Public Sector',
    description: 'Inquire about civic resilience planning, civil service modernization, or leadership qualification frameworks.'
  }, {
    icon: <MessageSquare size={24} data-id="element-274" data-mp="ncqc6o1xof99" />,
    title: 'Media & Press',
    description: "Media inquiries, interview requests, or information about SyNeural's mission and platform."
  }, {
    icon: <Mail size={24} data-id="element-275" data-mp="xaxmio1pvz2a" />,
    title: 'General Inquiries',
    description: 'Any other questions about SyNeural, our work, or how we might be able to help.'
  }];
  return <div className="min-h-screen bg-surface-bg" data-id="element-276" data-mp="9iyxz2d9c777">
      {/* Hero Section */}
      <section className="pt-32 pb-20 lg:pt-40 lg:pb-28 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-277" data-mp="4o35k143zhtk">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-278" data-mp="iey9cyzr38qa">
          <div className="inline-flex items-center gap-2 mb-6" data-id="element-279" data-mp="3i0dc5fp79hqc">
            <span className="w-8 h-px bg-teal" data-id="element-280" data-mp="1l122kiiondi3"></span>
            <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em]" data-id="element-281" data-mp="1l08vfgftalzf">
              Contact
            </span>
            <span className="w-8 h-px bg-teal" data-id="element-282" data-mp="1uqlmlri4tdej"></span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-ink-dark leading-tight mb-8" data-id="element-283" data-mp="1usevldg7w9pp">
            Get in Touch
          </h1>

          <p className="text-xl text-ink-muted leading-relaxed max-w-3xl mx-auto" data-id="element-284" data-mp="122fxksk1p28w">
            We're interested in hearing from organizations, institutions,
            researchers, and leaders who share our commitment to strengthening
            human capability, improving judgment quality, and building more
            resilient systems.
          </p>
        </motion.div>
      </section>

      {/* Contact Reasons */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-285" data-mp="2nehg6ncemp73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12 text-center" data-id="element-286" data-mp="2sdasicfyga5o">
          <h2 className="text-3xl font-heading font-bold text-ink-dark mb-4" data-id="element-287" data-mp="6ykt6osdyo3q">
            Reasons to Reach Out
          </h2>
          <p className="text-lg text-ink-muted max-w-2xl mx-auto" data-id="element-288" data-mp="3t7vwcxap9sf1">
            Whether you'We are exploring a partnership, requesting a demo, or
            have questions about our research – we'd like to hear from you.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-289" data-mp="3k7pihab3aqfc">
          {contactReasons.map((reason, index) => <motion.div key={reason.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-lg border border-line" data-id="element-290" data-mp="1ig2s9az0uzjx" data-mpi={index}>
              <div className="w-12 h-12 rounded-lg bg-teal/10 flex items-center justify-center text-teal mb-4" data-id="element-291" data-mp="63z4ddtok707">
                {reason.icon}
              </div>
              <h3 className="text-lg font-heading font-bold text-ink-dark mb-2" data-id="element-292" data-mp="3nivve8944pk5">
                {reason.title}
              </h3>
              <p className="text-sm text-ink-muted leading-relaxed" data-id="element-293" data-mp="3ekk6qbrt41uc">
                {reason.description}
              </p>
            </motion.div>)}
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-surface-muted border-y border-line" data-id="element-294" data-mp="34n5p48u5d70g">
        <div className="max-w-3xl mx-auto" data-id="element-295" data-mp="39lh0wp405rlb">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-296" data-mp="39nbl217g9foc">
            <div className="bg-white p-8 lg:p-12 rounded-xl border border-line shadow-sm" data-id="element-297" data-mp="2uxz3mbsrrz8x">
              <h2 className="text-3xl font-heading font-bold text-ink-dark mb-6 text-center" data-id="element-298" data-mp="38xrqtx537xc5">
                Send Us a Message
              </h2>
              <p className="text-ink-muted text-center mb-10" data-id="element-299" data-mp="34w6fig87br42">
                Fill out the form below and we'll get back to you as soon as
                possible.
              </p>

              <form className="space-y-6" data-id="element-300" data-mp="3dqb2gok7sieb">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-301" data-mp="3drcil7g37v2w">
                  <div data-id="element-302" data-mp="3smio7tb9trvp">
                    <label htmlFor="firstName" className="block text-sm font-medium text-ink-dark mb-2" data-id="element-303" data-mp="3sjwjs2jofshp">
                      First Name *
                    </label>
                    <input type="text" id="firstName" name="firstName" required className="w-full px-4 py-3 border border-line rounded-lg focus:outline-none focus:ring-2 focus:ring-teal focus:border-transparent" data-id="element-304" data-mp="3jb8188488ox" />
                  </div>
                  <div data-id="element-305" data-mp="makgrfa2atfg">
                    <label htmlFor="lastName" className="block text-sm font-medium text-ink-dark mb-2" data-id="element-306" data-mp="ma17so2e3fdk">
                      Last Name *
                    </label>
                    <input type="text" id="lastName" name="lastName" required className="w-full px-4 py-3 border border-line rounded-lg focus:outline-none focus:ring-2 focus:ring-teal focus:border-transparent" data-id="element-307" data-mp="w7fbro74mboz" />
                  </div>
                </div>

                <div data-id="element-308" data-mp="2louff3kzxlwb">
                  <label htmlFor="email" className="block text-sm font-medium text-ink-dark mb-2" data-id="element-309" data-mp="2lokpffzybeqm">
                    Email Address *
                  </label>
                  <input type="email" id="email" name="email" required className="w-full px-4 py-3 border border-line rounded-lg focus:outline-none focus:ring-2 focus:ring-teal focus:border-transparent" data-id="element-310" data-mp="2bpv57gkl1i77" />
                </div>

                <div data-id="element-311" data-mp="2uiz5vlw7wvbb">
                  <label htmlFor="organization" className="block text-sm font-medium text-ink-dark mb-2" data-id="element-312" data-mp="2uhnylc3kd5fg">
                    Organization
                  </label>
                  <input type="text" id="organization" name="organization" className="w-full px-4 py-3 border border-line rounded-lg focus:outline-none focus:ring-2 focus:ring-teal focus:border-transparent" data-id="element-313" data-mp="1j55326mevkdj" />
                </div>

                <div data-id="element-314" data-mp="23rtfr32i9483">
                  <label htmlFor="inquiryType" className="block text-sm font-medium text-ink-dark mb-2" data-id="element-315" data-mp="23t4kp67osi0s">
                    Inquiry Type *
                  </label>
                  <select id="inquiryType" name="inquiryType" required className="w-full px-4 py-3 border border-line rounded-lg focus:outline-none focus:ring-2 focus:ring-teal focus:border-transparent" data-id="element-316" data-mp="2wg8wpv575wm2">
                    <option value="" data-id="element-317" data-mp="3af8imv1brxej">Select an option</option>
                    <option value="partnership" data-id="element-318" data-mp="3f7i3vxrhw9ah">Partnership Inquiry</option>
                    <option value="demo" data-id="element-319" data-mp="13rzqvmsn1s7s">Platform Demo Request</option>
                    <option value="research" data-id="element-320" data-mp="13q6hhzqn4tw3">Research Collaboration</option>
                    <option value="government" data-id="element-321" data-mp="ysn6d8p8ox8d">
                      Government & Public Sector
                    </option>
                    <option value="media" data-id="element-322" data-mp="1dk5l736d4lq5">Media & Press</option>
                    <option value="general" data-id="element-323" data-mp="18karkrv7di1e">General Inquiry</option>
                  </select>
                </div>

                <div data-id="element-324" data-mp="ktnhbzxtegbo">
                  <label htmlFor="message" className="block text-sm font-medium text-ink-dark mb-2" data-id="element-325" data-mp="kv8apm8e7t7y">
                    Message *
                  </label>
                  <textarea id="message" name="message" rows={6} required className="w-full px-4 py-3 border border-line rounded-lg focus:outline-none focus:ring-2 focus:ring-teal focus:border-transparent resize-none" placeholder="Tell us about your inquiry..." data-id="element-326" data-mp="psroym53c5zw"></textarea>
                </div>

                <button type="submit" className="w-full bg-navy hover:bg-navy-light text-white font-medium px-8 py-4 rounded-lg transition-colors shadow-sm" data-id="element-327" data-mp="1suutkzaz71m4">
                  Send Message
                </button>

                <p className="text-xs text-ink-muted text-center" data-id="element-328" data-mp="1e4nm1emib307">
                  * Required fields
                </p>
              </form>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Additional Contact Info */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-329" data-mp="154r03kri4i8u">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-330" data-mp="10660nnk2q2lg">
          <h2 className="text-3xl font-heading font-bold text-ink-dark mb-8 text-center" data-id="element-331" data-mp="321wqa4f0415n">
            Other Ways to Connect
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-332" data-mp="36zepv474p40z">
            <div className="bg-surface-muted p-8 rounded-lg border border-line text-center" data-id="element-333" data-mp="3bszs58fr8k5z">
              <div className="w-14 h-14 rounded-full bg-teal/10 flex items-center justify-center text-teal mx-auto mb-4" data-id="element-334" data-mp="3gq9fmijl2lr6">
                <Mail size={28} data-id="element-335" data-mp="2j5wvymyjwliw" />
              </div>
              <h3 className="text-xl font-heading font-bold text-ink-dark mb-2" data-id="element-336" data-mp="2o23tbrcvsop8">
                Email Us Directly
              </h3>
              <p className="text-ink-muted mb-4" data-id="element-337" data-mp="2t0f547mql9a3">For general inquiries</p>
              <a href="mailto:contact@syneural.com" className="text-teal font-medium hover:underline" data-id="element-338" data-mp="2y24dffikr8uh">
                contact@syneural.com
              </a>
            </div>

            <div className="bg-surface-muted p-8 rounded-lg border border-line text-center" data-id="element-339" data-mp="d9asfzkuih8h">
              <div className="w-14 h-14 rounded-full bg-navy/10 flex items-center justify-center text-navy mx-auto mb-4" data-id="element-340" data-mp="29cfeezp6s5b4">
                <Building2 size={28} data-id="element-341" data-mp="24h03ogmh6pix" />
              </div>
              <h3 className="text-xl font-heading font-bold text-ink-dark mb-2" data-id="element-342" data-mp="2idne9m7cpe7b">
                Partnership Inquiries
              </h3>
              <p className="text-ink-muted mb-4" data-id="element-343" data-mp="2eaz1x4jfhp5l">
                For institutional partnerships
              </p>
              <a href="mailto:partnerships@syneural.com" className="text-navy font-medium hover:underline" data-id="element-344" data-mp="1loecwaqfdp57">
                partnerships@syneural.com
              </a>
            </div>
          </div>
        </motion.div>
      </section>

      {/* Response Time Notice */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-navy-deep text-white" data-id="element-345" data-mp="16z01yy77aznp">
        <div className="max-w-3xl mx-auto text-center" data-id="element-346" data-mp="12xwmwdwz97nj">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-347" data-mp="12x4ypo5pmc7a">
            <h3 className="text-2xl font-heading font-bold mb-4" data-id="element-348" data-mp="nuwkpj0zscqu">
              We'll Get Back to You Soon
            </h3>
            <p className="text-lg opacity-90" data-id="element-349" data-mp="1bjxupaph3vy8">
              We typically respond to inquiries within 2-3 business days. For
              urgent matters, please indicate that in your message.
            </p>
          </motion.div>
        </div>
      </section>
    </div>;
}